import { styled } from '@mui/material'

export const SectionWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  borderBottom: `1px solid ${theme.colours.new.gray200}`,
}))
